import { Injectable } from '@angular/core';
import { TelemetryRelayService } from './telemetry-relay.service';

@Injectable({ providedIn: 'root' })
export class MixpanelService {
  constructor(private telemetry: TelemetryRelayService) {}

  init(
    email: string,
    firstName: string,
    userId: string,
    lastName: string,
    userGroup: string,
    userType: string,
  ): void {
    this.telemetry.identify(
      false,
      userId,
      email,
      firstName,
      lastName,
      userGroup,
      userType,
    );
  }

  webviewInit(email: string): void {
    // webview only has email — send a minimal profiler and set identity
    this.telemetry.identify(false, email, email);
  }

  ltiInit(email: string, userId: string, userType: string): void {
    this.telemetry.identify(
      true,
      userId,
      email,
      undefined,
      undefined,
      undefined,
      userType,
    );
  }

  track(event_name: string, properties: any = {}): void {
    this.telemetry.track(event_name, properties);
  }

  reset(): void {
    this.telemetry.reset();
  }
}
